import { inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class ToastMessageService {
  private readonly messageService = inject(MessageService);

  success(detail: string, summary = 'Success', life?: number): void {
    this.messageService.add({
      severity: 'success',
      summary,
      detail,
      life: life || 3000,
    });
  }

  error(detail: string, summary = 'Error', life?: number): void {
    this.messageService.add({
      severity: 'error',
      summary,
      detail,
      life: life || 3000,
    });
  }

  info(detail: string, summary = 'Info', life?: number): void {
    this.messageService.add({
      severity: 'info',
      summary,
      detail,
      life: life || 3000,
    });
  }

  warn(detail: string, summary = 'Warning', life?: number): void {
    this.messageService.add({
      severity: 'warn',
      summary,
      detail,
      life: life || 3000,
    });
  }
}
